module.exports = __webpack_public_path__ + "img/main_Ablast.bb793254.jpg";